import { ToastContainer } from "react-bootstrap";
import './ParagonToastContainer.css';

export function ParagonToastContainer({children}) {
    return (
      <ToastContainer className="paragon-toast-container">
        {children}
      </ToastContainer>   
    )
}